import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';

export default class BrandBucket extends React.PureComponent {
    static propTypes = {
        middleImage: PropTypes.string,
        middleSmallImage: PropTypes.string,
    };

    state = {
        visible: false,
    };

    _handleWaypointEnter = () => {
        this.setState({ visible: true });
    };

    render() {
        const { middleImage, middleSmallImage } = this.props;

        let content = (
            <div
                className="
                    content-bucket
                    branding-image-container
                    branding-image-container__middle
                    eds-l-mar-vert-16
                    eds-l-sw-mar-vert-10
                    eds-l-sm-mar-vert-10
                    eds-l-sn-mar-vert-10
                    eds-align--center-horizontal
                "
            >
                <img
                    srcSet={`
                        ${middleSmallImage} 512w,
                        ${middleImage} 1272w
                    `}
                    sizes="
                        (max-width: 512px) 100vw,
                        1272px
                    "
                    src={middleImage}
                    alt=""
                    className="branding-image-container__middle-image"
                />
            </div>
        );

        if (!this.state.visible) {
            content = undefined;
        }

        return (
            <Waypoint onEnter={this._handleWaypointEnter}>{content}</Waypoint>
        );
    }
}
